<template>
	<div>
		<h3>Categorization</h3>

		<template v-if="$store.service.contract_id > 0">
			<p>Categorization is set on the service contract</p>

			<field 
				label="Category" 
				col-class="col-md-3 col-lg-2" 
				:value="$store.service && 'ServiceContract' in $store.service && $store.service.ServiceContract ? $store.service.ServiceContract.category_id : null" 
				readonly
				:params="{type: 'select', options: categoryOptions}" 
				:readonly="readonly || isNewEmergency || $store.service.contract_id > 0" :invalid="$store.errorList.category_id">
			</field>
			
			<field 
				label="Revenue Code" 
				col-class="col-md-3 col-lg-2" 
				:value="$store.service && 'ServiceContract' in $store.service && $store.service.ServiceContract ? $store.service.ServiceContract.revenue_code_id : null"
				readonly
				:params="{type: 'select', options: revenueCodeOptions}" 
				:readonly="readonly || isNewEmergency || $store.service.contract_id > 0" :invalid="$store.errorList.revenue_code_id">
			</field>
		</template>
		<template v-else>
			<field 
				label="Category" 
				col-class="col-md-3 col-lg-2"
				v-model="$store.service.category_id"
				:params="{type: 'select', options: categoryOptions}" 
				v-on:change="$emit('categorySelected',$event)"
				:readonly="readonly || isNewEmergency || $store.service.contract_id > 0" :invalid="$store.errorList.category_id">
			</field>

			<field 
				label="Revenue Code" 
				col-class="col-md-3 col-lg-2" 
				v-model="$store.service.revenue_code_id" 
				:params="{type: 'select', options: revenueCodeOptions}" 
				:readonly="readonly || isNewEmergency || $store.service.contract_id > 0" :invalid="$store.errorList.revenue_code_id">
			</field>
		</template>
	</div>
</template>
<script type="text/javascript">
import Field from "@/components/Field"

export default {
	name:"CategorizationSection",
	components: {
		Field
	},
	props: ["isNewEmergency","readonly"],
	created() {

		let vm = this
		this.$bus.$on("contractIdChange",(contractId) => {
			vm.$store.service.contract_id = contractId
			vm.$forceUpdate()
		})
	}
}
</script>